import { AppShot } from "./AppShot";

const STEPS = [
  {
    num: "01",
    title: "Carica",
    lead: "Il catalogo che hai già, dentro in giornata.",
    desc: "Importi utensili, attacchi base e materie prime da Excel o CSV: l'import controlla il file riga per riga e ti segnala gli errori prima di salvare. Assegni magazzino, posizione fisica e scorta minima e il magazzino è tracciato.",
    shot: "app-catalogo.jpg",
    label: "CATALOGO UTENSILI",
    alt: "Catalogo utensili con codici, fornitori, brand e scorte per magazzino",
    caption: "Catalogo utensili: codice, fornitore, brand, giacenza e scorta minima per magazzino.",
  },
  {
    num: "02",
    title: "Controlla",
    lead: "Cosa manca, cosa si muove, chi lo ha preso.",
    desc: "Il quadro utensili mostra le referenze sotto scorta, i prelievi del mese e l'ultimo movimento con operatore, magazzino e quantità. La produzione avanza sulle fasi: ore reali, pezzi buoni, scarti e rilavorati.",
    shot: "app-quadro.jpg",
    label: "QUADRO UTENSILI",
    alt: "Quadro utensili con scorte da riordinare e ultimi movimenti tracciati",
    caption: "Scorte da riordinare e tracciabilità dei movimenti, aggiornate a ogni prelievo.",
  },
  {
    num: "03",
    title: "Decidi",
    lead: "Prezzi e margini con i tuoi dati, non a sentimento.",
    desc: "Tempi dai parametri di taglio o dalle fasi del tuo ciclo, tariffa oraria per macchina, costo industriale, margine e prezzo proposto mentre scrivi. A lavoro finito confronti il preventivo con le ore reali di officina.",
    shot: "app-preventivi.jpg",
    label: "PREVENTIVI",
    alt: "Elenco preventivi con valore offerto, margine medio e affidabilità della stima",
    caption: "Preventivi con valore offerto, margine e affidabilità della stima su ogni riga.",
  },
];

export function ThreeStepsSection() {
  return (
    <section className="landing-steps" id="come-funziona" data-testid="landing-steps">
      <div className="landing-section-head landing-reveal">
        <p className="landing-module-num">COME FUNZIONA <i /> IN TRE MOSSE</p>
        <h2>Operativa in tre mosse, non in tre mesi</h2>
        <p className="landing-desc">
          Nessun progetto lungo un anno: si parte dal magazzino utensili e si aggiunge un modulo alla volta,
          quando serve.
        </p>
      </div>

      {STEPS.map((step, index) => (
        <article
          className={`landing-step${index % 2 ? " is-mirrored" : ""}`}
          key={step.num}
          data-testid={`landing-step-${index + 1}`}
        >
          <div className="landing-step-copy landing-reveal">
            <p className="landing-module-num">{step.num} <i /> {step.title.toUpperCase()}</p>
            <h3>{step.lead}</h3>
            <p className="landing-desc">{step.desc}</p>
          </div>
          <AppShot
            src={step.shot}
            alt={step.alt}
            label={step.label}
            caption={step.caption}
            testId={`landing-step-shot-${index + 1}`}
          />
        </article>
      ))}
    </section>
  );
}
